// Port of api/fuel/app/classes/insights/plays/rankings.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'rankings',
    insight: ['ranking.band'],
    detail: false,
    requires: ['overview'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        var own = []
        var bands = []
        var stats = {
            top100: 0,
            top1000: 0,
            ranked: 0,
            highest: 0,
            lowest: 0,
            longest: [0, 0],
            levels: 0,
            levelmost: [0, 0],
            levelnone: [0, 0]
        }

        var currentBand = filter['ranking.band'] || 1

        var playRows = Util.queryFast(
            'SELECT g.game_id AS g, g.game_rank AS r, SUM(p.play_count) AS p' +
            ' FROM play p JOIN game g' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.game_id = g.game_id' +
            ' AND g.game_type = 1' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date <= ' + (range.end - 1) +
            sqlCount +
            ' GROUP BY g.game_id' +
            ' ORDER BY g.game_rank'
        )
        var playIndex = Util.keyed_array(playRows, 'g')

        if (!playRows.length) return {}

        var streakCount = 0
        var streakLast = null
        var streakStart = 0
        var streakEnd = 0
        var streakLongest = 0
        var rankedTotal = 0

        if (owner.get_count_plays()) {

            var maxRank = 0
            var minRank = 0

            for (var pi = 0; pi < playRows.length; pi++) {
                var item = playRows[pi]
                var rank = parseInt(item.r, 10)

                if (rank > 0) {

                    rankedTotal++

                    if (streakLast === null || (streakLast !== null && rank - streakLast === 1)) {
                        streakLast = rank
                        streakCount++
                    } else {
                        if (streakCount > streakLongest) {
                            streakLongest = streakCount
                            streakStart = streakLast - (streakCount - 1)
                            streakEnd = streakLast
                        }
                        streakCount = 1
                        streakLast = rank
                    }

                    if (!minRank) minRank = item

                    if (!maxRank || rank > parseInt(maxRank.r, 10)) {
                        maxRank = item
                    }
                }
            }

            // Check final streak
            if (streakCount > streakLongest) {
                streakLongest = streakCount
                streakStart = streakLast - (streakCount - 1)
                streakEnd = streakLast
            }

            var minBandRank = (currentBand * 100) + 1
            var maxBandRank = (currentBand + 1) * 100

            var maxRankValue = parseInt(maxRank.r, 10)
            for (var bi = 0; bi < Math.ceil(maxRankValue / 100); bi++) {
                bands.push(0)
            }

            for (var bj = 0; bj < playRows.length; bj++) {
                var bItem = playRows[bj]
                var bRank = parseInt(bItem.r, 10)

                if (bRank > 0) {
                    bands[Math.floor((bRank - 1) / 100)] += parseInt(bItem.p, 10)
                }
            }

            // No Booster offline, so game! becomes game
            var gameIndex = Util.queryFast(
                'SELECT g.game_id AS g, g.game_rank AS r' +
                ' FROM game g' +
                ' WHERE g.game_rank >= ' + minBandRank +
                ' AND g.game_rank <= ' + maxBandRank +
                ' ORDER BY g.game_rank' +
                ' LIMIT 0, 100',
                null, 'r'
            )

            for (var gi = minBandRank; gi <= maxBandRank; gi++) {
                if (gameIndex[gi]) {
                    this._references.games.push(gameIndex[gi].g)

                    own.push({
                        id: parseInt(gameIndex[gi].g, 10),
                        rank: gi,
                        own: !!playIndex[gameIndex[gi].g]
                    })
                } else {
                    own.push({
                        id: 0,
                        rank: gi,
                        own: false
                    })
                }
            }

            var bandMostCount = 0
            var bandMostLevel = 0
            var bandNoneLevel = null

            for (var bk = 0; bk < bands.length; bk++) {
                if (bands[bk]) stats.levels++

                if (bandMostCount < bands[bk]) {
                    bandMostLevel = bk
                    bandMostCount = bands[bk]
                }

                if (!bands[bk] && bandNoneLevel === null) {
                    bandNoneLevel = bk
                }
            }

            stats.longest[0] = streakStart
            stats.longest[1] = streakEnd

            stats.levelmost[0] = (bandMostLevel * 100) + 1
            stats.levelmost[1] = (bandMostLevel + 1) * 100

            if (bandNoneLevel !== null) {
                stats.levelnone[0] = (bandNoneLevel * 100) + 1
                stats.levelnone[1] = (bandNoneLevel + 1) * 100
            }

            stats.highest = parseInt(minRank.r, 10)
            stats.lowest = parseInt(maxRank.r, 10)

            var overviewPlays = this._data.overview ? this._data.overview.plays : 0
            var overviewGames = this._data.overview ? this._data.overview.games : 0

            if (overviewPlays) {
                stats.top100 = (100 / overviewPlays) * bands[0]
                var top1000Sum = 0
                for (var ti = 0; ti < 10 && ti < bands.length; ti++) {
                    top1000Sum += bands[ti]
                }
                stats.top1000 = (100 / overviewPlays) * top1000Sum
            }

            if (overviewGames) {
                stats.ranked = (100 / overviewGames) * rankedTotal
            }
        }

        return {
            rankings: {
                own: own,
                stats: stats,
                bands: bands
            }
        }

    }
})
